import * as Types from '../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ResetPasswordWithTokenMutationVariables = Types.Exact<{
  userId: Types.Scalars['ID']['input'];
  input: Types.ResetPasswordWithTokenInput;
}>;


export type ResetPasswordWithTokenMutation = { __typename?: 'RootMutationType', resetPasswordWithToken: { __typename?: 'ResetPasswordResult', success: boolean, error?: string | null } };


export const ResetPasswordWithTokenDocument = gql`
    mutation resetPasswordWithToken($userId: ID!, $input: ResetPasswordWithTokenInput!) {
  resetPasswordWithToken(userId: $userId, input: $input) {
    success
    error
  }
}
    `;
export type ResetPasswordWithTokenMutationFn = Apollo.MutationFunction<ResetPasswordWithTokenMutation, ResetPasswordWithTokenMutationVariables>;

/**
 * __useResetPasswordWithTokenMutation__
 *
 * To run a mutation, you first call `useResetPasswordWithTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordWithTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordWithTokenMutation, { data, loading, error }] = useResetPasswordWithTokenMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordWithTokenMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordWithTokenMutation, ResetPasswordWithTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordWithTokenMutation, ResetPasswordWithTokenMutationVariables>(ResetPasswordWithTokenDocument, options);
      }
export type ResetPasswordWithTokenMutationHookResult = ReturnType<typeof useResetPasswordWithTokenMutation>;
export type ResetPasswordWithTokenMutationResult = Apollo.MutationResult<ResetPasswordWithTokenMutation>;
export type ResetPasswordWithTokenMutationOptions = Apollo.BaseMutationOptions<ResetPasswordWithTokenMutation, ResetPasswordWithTokenMutationVariables>;